export default __webpack_public_path__ + "static/media/logo.0fd750e9.png";